(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["countdown-drop"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
      // Get the countdown timer element
      var countdownTimer = document.querySelector('[data-timer-settings]');

      // Get the countdown data from the JSON script element
      var countdownDataElement = document.getElementById('timer-settings');
      var countdownData = JSON.parse(countdownDataElement.textContent);

      var newDate = countdownData.date.split('/');
      var day = parseInt(newDate[0]);
      var month = parseInt(newDate[1]);
      var year = parseInt(newDate[2]);

      // Set the countdown date
      var countdownDate = new Date(year, month - 1, day, countdownData.hour, 0);

  // Function to update the countdown numbers
    function updateCountdown() {

      // Calculate the remaining time
      var currentTime = new Date();
      var timeDifference = countdownDate - currentTime;

      var days = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
      var hours = Math.floor((timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      var minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((timeDifference % (1000 * 60)) / 1000);

      // Update the countdown numbers
      var daysElement = document.querySelector('[data-days]');
      var hoursElement = document.querySelector('[data-hours]');
      var minutesElement = document.querySelector('[data-minutes]');
      var secondsElement = document.querySelector('[data-seconds]');

      daysElement.textContent = days;
      hoursElement.textContent = hours;
      minutesElement.textContent = minutes;
      secondsElement.textContent = seconds;
    }

    // Call the updateCountdown function initially
    updateCountdown();

    // Update the countdown every second
    setInterval(updateCountdown, 1000);
  }, false);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".product-recommendations").innerHTML;
      theme.ProductBlockManager.loadImages(productRecommendationsSection);
      theme.initAnimateOnScroll();
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
